import React from "react";
import {ListDate} from "./Event";
import {format, isToday} from "date-fns";
import {makeStyles} from "@mui/styles";
import DayRotaSummary from './DayRotaSummary';
import WeekEvents from './WeekEvents';

const useStyles = makeStyles((theme) => ({
  datePeriod: {
    minWidth: 0,
    marginBottom: 0,
    borderTop: '1px solid #ccc',
    pointerEvents: 'none',
  },
  weekdayGrid: {
    display: 'grid',
    gap:8,
    gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
  },
  compactGrid: {gap: 3},
}));

export const EventList = ({events = [], edit=()=>{}, mode = 'week', onDelete, rota, compact = false}) => {
  const classes = useStyles();
  const gridClass = `${classes.weekdayGrid} ${compact ? classes.compactGrid : ''}`;

  const weeks = Array.from({length: Math.ceil(events.length / 7)}, (_, index) => events.slice(index * 7, index * 7 + 7));
  return <div>
    <div className={gridClass}>
      {events.slice(0, 7).map(day => <div key={day.date} style={{fontSize: compact ? 10 : 14, padding: '8px 2px 10px'}}>
        {format(day.date, 'EEE')}
      </div>)}
    </div>
    {weeks.map((week, weekIndex) => {
      const firstEventRow = rota ? 3 : 2;
      return <div key={weekIndex} className={gridClass}
        style={{gridAutoRows: 'max-content', alignContent: 'start', rowGap: 0,
          minHeight: mode === 'month' ? 120 : 200, paddingBottom: 16, position: 'relative', isolation: 'isolate'}}>
        {week.map((day, dayIndex) => <React.Fragment key={day.date}>
          <div className={`${classes.datePeriod} ${isToday(day.date) ? 'today' : ''}`}
            style={{gridColumn: `${dayIndex + 1} / ${dayIndex + 2}`, position: 'absolute',
              top: 0, bottom: 0, left: 0, right: 0, zIndex: -1}} />
          <div style={{gridColumn: dayIndex + 1, gridRow: 1, minWidth: 0, padding: '0 2px', position: 'relative'}}>
            <ListDate compact={compact} label={format(day.date, compact ? 'do' : mode === 'week' ? 'do MMM' : 'do')}
              opacity={!day.inCurrentMonth && mode === 'month' ? 0.6 : 1} />
          </div>
          {rota && <div style={{gridColumn: dayIndex + 1, gridRow: 2, minWidth: 0, padding: '0 2px', position: 'relative'}}>
            <DayRotaSummary compact={compact} summary={rota.days[format(day.date, 'yyyy-MM-dd')]} loading={rota.loading} error={rota.error} />
          </div>}
        </React.Fragment>)}
        <WeekEvents week={week} weekIndex={weekIndex} gridRow={firstEventRow}
          className={gridClass} edit={edit} onDelete={onDelete} compact={compact} />
      </div>;
    })}
    {!events.length && <p>No events found, please adjust the filters.</p>}
  </div>;
};
